var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vuex-breadcrumb'),_c('product-listing-create',{attrs:{"ams_template":_vm.ams_template,"reroute":_vm.reroute}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }